﻿import MainWindowCuiLayout from './MainWindowCuiLayout';
import TocEditorCuiLayout from './TocEditor/TocEditorCuiLayout';

window.MainWindowCuiLayout = MainWindowCuiLayout;
window.TocEditorCuiLayout = TocEditorCuiLayout;
